import React from "react";
import styled from "styled-components";

export default styled.button`
    background: white;
    color: #909090;
    padding: 9px 13px;
    display: inline-block;
    margin-left: 28px;
    border: 0;
    font-family: 'Effra',sans-serif;
    font-size: 20px;
    top: -42px;
    position: relative;
    box-shadow: 0px 0px 25px #5562c04f;
    
    ${(props) => (props.purple ? {
    'background': '#5562c0',
    'color': 'white',
} : '')}
`;